import React from "react";

import { Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  const handleBackPage = () => {
    navigate("/");
  };

  return (
    <div className="w-full h-screen">
      <div className="flex flex-col justify-center  w-full h-full ">
        <div className="flex flex-row justify-center">
          <div className="flex flex-col gap-5">
            <h1>OOPS .. This page doesnt exist </h1>
            <Button variant="solid" onClick={handleBackPage}>
              Go Back!
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
